import React, { Component } from 'react';

export default class DynamicPageRedirectRuleForm extends Component {
  state = {
    fieldValue: this.props.paramRow.fieldValue,
    target: this.props.paramRow.target,
    page: this.props.paramRow.page,
    pathField: this.props.paramRow.pathField,
    seoField: this.props.paramRow.seoField,
    fieldCollectionSource: this.props.paramRow.fieldCollectionSource,
  };

  onChange = ({ target: { name, value, type, checked } }) => {
    const finalValue = type === 'checkbox' ? checked : value;

    this.setState({
      ...this.state,
      [name]: finalValue,
    });
    this.props.paramRow[name] = finalValue;
    this.props.createNewRow(this.props.paramRow);
  };

  onCustomSelectChange = (name, value) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
    this.props.paramRow[name] = value;
    this.props.createNewRow(this.props.paramRow);
  };

  render() {
    const { collectionFrom } = this.props;
    return (
      <tr>
        <td>
          {collectionFrom === 'sessionActionResponse' && (
            <input
              className="form-control form-control-sm"
              placeholder="Session Field Value"
              type="text"
              name="fieldValue"
              onChange={this.onChange}
              value={this.state.fieldValue}
            />
          )}
          {collectionFrom !== 'sessionActionResponse' && (
            <select
              name="fieldValue"
              onChange={this.onChange}
              className="form-control form-control-sm custom-select-sm"
              value={this.state.fieldValue}
            >
              <option value="">- Select One -</option>
              {this.props.collectionFieldValueOptions.map((e) => (
                <option key={e.value} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
          )}
        </td>
        <td>
          <select
            name="page"
            onChange={this.onChange}
            className="form-control form-control-sm custom-select-sm"
            value={this.state.page}
          >
            <option value="">- Select One -</option>
            {this.props.pageOptions.map((e) => (
              <option key={e.value} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>
        </td>
        <td className="text-center">
          {/* <input
            type="checkbox"
            name="target"
            checked={this.state.target}
            className="form-control form-control-sm"
            onChange={this.onChange}
          /> */}

          <div className="form-check">
            <label className="form-check-label" style={{ padding: '5px 5px 0 10px' }}>
              <input
                type="checkbox"
                name="target"
                className="form-check-input"
                onChange={this.onChange}
                checked={this.state.target ? 'checked' : ''}
              />
              <span className="form-check-sign">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </td>
        <td>
          <select
            name="pathField"
            onChange={this.onChange}
            className="form-control form-control-sm custom-select-sm"
            value={this.state.pathField}
          >
            <option value="">- Select One -</option>
            {this.props.pathFieldOptions.map((e) => (
              <option key={e.value} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>
        </td>
        {collectionFrom !== 'sessionActionResponse' && (
          <>
            <td>
              <select
                name="seoField"
                onChange={this.onChange}
                className="form-control form-control-sm custom-select-sm"
                value={this.state.seoField}
              >
                <option value="">- Select One -</option>
                {this.props.seoFieldOptions.map((e) => (
                  <option key={e.value} value={e.value}>
                    {e.label}
                  </option>
                ))}
              </select>
            </td>
          </>
        )}
        <td>
          <select
            name="fieldCollectionSource"
            onChange={this.onChange}
            className="form-control form-control-sm custom-select-sm"
            value={this.state.fieldCollectionSource}
          >
            <option value="">- Select One -</option>
            {this.props.fieldCollectionSourceOptions.map((e) => (
              <option key={e.value} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>
        </td>
      </tr>
    );
  }
}
